import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { PublicAuthProvider } from './context/PublicAuthContext';

createRoot(document.getElementById('root')).render(<StrictMode><PublicAuthProvider><App /></PublicAuthProvider></StrictMode>);
